<template>
<div class="addfollowup" :class="{active:status !== '2'}">
  <div class="addfollowup--header">
    <div class="addfollowup--header--title">
      <div class="title--cancle" @click="handleToCanCelAddRecordBtn($route.params.routerName,$route.params.routeTag)">取消</div>
      <div class="title--text">{{ ($route.params.routerName&&$route.params.modifyTag)||(mmFollowRecordHisList.length>0)?'修改':'新增'}}营销日志</div>
      <div class="title--complete" @click="handleToSubmitFollowRecord($route.params.routerName,$route.params.id)">
        <template v-if="contentReadOnly">提交</template>
      </div>
    </div>
  </div>
  <div class="addfollowup--line"></div>
  <div class="addfollowup--info">
    <div class="addfollowup--info--item" @click="contentReadOnly && handleToRecordGetVisitCustom()">
      <div class="item--text">拜访客户/渠道</div>
      <div class="item--desc">{{cusName?cusName:'点击选择'}}</div>
      <div class="item--icon iconfont" v-if="contentReadOnly">&#xe62c;</div>
    </div>
    <div class="addfollowup--info--item" v-if="false">
<!--      <div class="item&#45;&#45;text"></div>-->
      <div class="item--report"><a href="http://dcloud.zqfinancial.com:18080/qbzx">点击查询客户大数据风控报告</a></div>
      <div class="item--icon iconfont">&#xe62c;</div>
    </div>
    <div class="addfollowup--info--item" @click="isDatePickerShow = contentReadOnly">
      <div class="item--text">拜访日期</div>
      <div class="item--desc">{{visitDate?visitDate:'点击选择'}}</div>
      <div class="item--icon iconfont" v-if="contentReadOnly">&#xe62c;</div>
    </div>
    <div class="addfollowup--info--item" @click="contentReadOnly && handleToRecordGetVisitMode()">
      <div class="item--text">跟进方式</div>
      <div class="item--desc">{{followType_text?followType_text:'点击选择'}}</div>
      <div class="item--icon iconfont" v-if="contentReadOnly">&#xe62c;</div>
    </div>
    <div class="addfollowup--info--item" @click="contentReadOnly && handleToRecordToMap()" v-if="followType === '1'">
      <div class="item--text">地址</div>
      <div class="item--desc">{{this.$store.state.locationData.address?this.$store.state.locationData.address:'点击获取定位'}}</div>
      <div class="item--icon iconfont" v-if="contentReadOnly">&#xe62b;</div>
    </div>
    <div class="addfollowup--info--item" v-if="followType === '1'">
      <div class="item--text">定位时间</div>
      <div class="item--desc">{{this.$store.state.locationData.locationDate}}</div>
      <div class="item--icon iconfont"></div>
    </div>
    <div class="addfollowup--info--item">
      <div class="item--text">是否继续跟进</div>
      <div class="item--radio">
        <van-radio-group v-model="isContinue" direction="horizontal" :disabled="!contentReadOnly">
          <van-radio name="1">是</van-radio>
          <van-radio name="2" @click="contentReadOnly && handleToChangeIsContinue()">否</van-radio>
        </van-radio-group>
      </div>
    </div>

    <div class="addfollowup--info--item" v-if="contentReadOnly">
      <md-textarea-item
        ref="demo0"
        autosize
        clearable
        class="example"
        v-model="remark"
        placeholder="拜访信息记录"
      />
    </div>
    <div class="addfollowup--info--noinput" v-else>
      {{remark}}
    </div>
    <div class="addfollowup--info--img">
      <div class="md-example-child md-example-child-reader md-example-child-reader-0">
        <div>
          <ul class="image-reader-list">
              <li
                class="image-reader-item"
                v-for="(img, index) in followupimgs"
                :key="index"
                @click="showViewer(index, $event)"
                :style="{
                  'backgroundImage': `url(${img})`,
                  'backgroundPosition': 'center center',
                  'backgroundRepeat': 'no-repeat',
                  'backgroundSize': 'cover'
                }"
              >
                <md-tag
                  v-if="contentReadOnly"
                  class="image-reader-item-del"
                  size="small"
                  shape="quarter"
                  fill-color="#111A34"
                  type="fill"
                  font-color="#fff"
                  @click.native.stop="handleToDeleteImage(index)"
                >
                  <md-icon name="close"></md-icon>
                </md-tag>
              </li>
          </ul>
        </div>
        <md-image-viewer
          v-model="followupisViewerShow"
          :list="followupimgs"
          :has-dots="true"
          :initial-index="followupviewerIndex">
        </md-image-viewer>
      </div>
    </div>
    <div class="addfollowup--info--camera" v-if="contentReadOnly">
      <div class="item--img--icon">
        <van-uploader :after-read="afterAddFollowupRead" :multiple="true"/>
<!--        <van-uploader multiple :after-read="afterAddFollowupRead" />-->
      </div>
    </div>
    <div class="addfollowup--info--item" v-if="false">
      <div class="item--text">下次跟进计划</div>
      <div class="item--desc">下次跟进计划</div>
      <div class="item--icon iconfont">&#xe62c;</div>
    </div>
    <div class="addfollowup--info--person">
      <div class="item--persons--title">参与人</div>
      <div class="item--persons--desc">
        <div
          class="desc--person"
          v-for="(item,index) in mmRecordStaffList"
          :key="item.actorno+index"
        >{{item.actorname}}</div>
        <div
          class="desc--person desc--person--plus iconfont"
          @click="handleToRecordGetFollowPerson"
          v-if="contentReadOnly"
        >&#xe602;</div>
      </div>
    </div>
    <div class="addfollowup--info--version" v-if="mmFollowRecordHisList.length > 0">
      <div class="version--title">版本信息</div>
      <div
        class="version--item"
        :class="{active:hisitem.id === hisId}"
        v-for="hisitem in mmFollowRecordHisList"
        :key="hisitem.id"
        @click="handleToHisRecord(hisitem)"
      >
        <div class="version--item--text">{{hisitem.updateDate.split(' ')[0]}}版本</div>
        <div class="version--item--desc"></div>
        <div class="version--item--icon iconfont">&#xe62c;</div>
      </div>
    </div>
  </div>
  <div class="addfollowup--footer" v-if="status !== '2'">
    <div class="addfollowup--footer--save" @click="handleToSaveFollowRecord($route.params.routerName,$route.params.id)">保存为草稿</div>
    <div class="addfollowup--footer--del" @click="handleToDelFollowRecord($route.params.routerName,$route.params.id)">删除</div>
  </div>
  <div class="md-example-child md-example-child-date-picker md-example-child-date-picker-3">
    <md-date-picker
      ref="datePicker"
      v-model="isDatePickerShow"
      type="custom"
      title="选择拜访日期"
      large-radius
      :text-render="textRender"
      :custom-types="['yyyy','MM','dd']"
      :default-date="currentDate"
      @confirm="onDatePickerConfirm"
    ></md-date-picker>
  </div>
  <div class="addfollowup--visit" v-if="visitModeFlag">
    <div class="visit--title">
      <div class="title--back iconfont" @click="handleToCancleSelectCustom">&#xe600;</div>
      <div class="visit--title--text">选择拜访客户/渠道</div>
      <div class="title--add iconfont" @click="handleToForwardAddSelectMM">&#xe602;</div>
    </div>
    <div class="visit--line"></div>
    <template v-if="visitCustomList.length">
      <div
        class="visit--item"
        v-for="item in visitCustomList"
        :key="item.id"
        @click="handleToSelectVisitCustom(item)"
      >
        <div class="visit--item--icon iconfont">&#xe629;</div>
        <div class="visit--item--text">{{item.cusName}}</div>
      </div>
    </template>
    <template v-else>
      <div
        class="visit--item"
      >
        <div class="visit--item--text">暂无数据，点击新增</div>
      </div>
    </template>
  </div>
  <div class="addfollowup--visit" v-if="false">
    <div class="visit--title">
      <div class="visit--title--text">选择跟进方式</div>
    </div>
    <div
      class="visit--item"
      v-for="(item,index) in followTypeList"
      :key="item.cnname+index"
      @click="handleToSelectVisitMode(item)"
    >
      <div class="visit--item--icon iconfont">&#xe629;</div>
      <div class="visit--item--text">
        <div class="text-title">{{item.cnname}}</div>
        <div class="text-desc">通过电话、微信、邮件等远程方式沟通</div>
      </div>
    </div>
  </div>
  <van-popup
    v-model="followTypeFlag"
    :close-on-click-overlay="false"
    position="bottom"
    :style="{ height: '30%' }"
  >
    <van-picker
      title="选择跟进方式"
      show-toolbar
      :visible-item-count="2"
      :columns="FollowTypeTextList"
      :default-index="0"
      @cancel="handleToFollowCancleFloat"
      @confirm="handleToSelectVisitMode"
    />
  </van-popup>
  <div class="addfollowup--visit" v-if="followRecordFlag">
    <div class="visit--title">
      <div class="visit--title--cancle"></div>
      <div class="visit--title--text">选择参与人</div>
      <div class="visit--title--cancle" @click="handleToAddRecordPersonComplete">完成</div>
    </div>
    <div class="visit--line"></div>
    <div class="visit--person">
      <div
        class="visit--person--content"
        :class="{active:mmRecordStaffTag.includes(item.actorno)}"
        v-for="item in followRecordPersonList"
        :key="item.actorno"
        @click="handleToAddRecordFollowPerson(item)"
      >{{item.actorname}}</div>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get, post, postfile, postjson } from '../api/api'
import { compressImage } from '../tools/CompressImageUtils'
import { DatePicker, Radio, TextareaItem, ImageViewer, Tag, ImageReader, Icon } from 'mand-mobile'
import { getFollowupType, getFormEmptyField } from '../tools/common'
export default {
  name: 'AddFollowup',
  components: {
    [Radio.name]: Radio,
    [TextareaItem.name]: TextareaItem,
    [DatePicker.name]: DatePicker,
    [ImageViewer.name]: ImageViewer,
    [Tag.name]: Tag,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon
  },
  data () {
    return {
      currentDate: new Date(), // 当前时间
      isDatePickerShow: false, // 控制日历显示
      followupisViewerShow: false, // 控制图是否全屏显示
      followupviewerIndex: 0, // 选择那张图片
      followupimgs: [], // 图片列表
      id: '', // 跟进记录id
      visitModeFlag: false, // 控制选择拜访客户页面显示
      visitCustomList: [], // 拜访客户列表
      certCode: '', // 营销事项的客户证件号
      cusName: '', // 营销事项的客户名称
      relMatterId: '', // 营销事项的客户id
      visitDate: '', // 拜访日期
      followTypeList: [], // 跟进方式列表
      FollowTypeTextList: [], // 跟进方式文本列表，用于显示
      followTypeFlag: false, // 控制选择跟进方式页面显示
      followType: '', // 跟进方式（数字）
      followType_text: '', // 跟进方式(文本，只作显示使用)
      isContinue: '1', //  是否跟进
      remark: '', // 拜访总结
      docEReceiveList: [], // 发送图片信息
      followRecordPersonList: [], // 所有跟进跟进人列表
      followRecordFlag: false, // 控制选择跟进人页面显示
      mmRecordStaffList: [], // 已选择跟进人
      mmRecordStaffTag: [], // 已选择跟进人tag
      mmFollowRecordHisList: [], // 历史版本信息
      hisId: '', // 控制当前历史版本
      status: '', // 当前跟进记录什么状态
      checkFieldList: [], // 校验表单是否有空
      FollowTypeText: [],
      couldEdit: true, // 控制不是改事项创建人、参与人是否可见、可编辑、可添加
      postFlag: true, // 控制提交一次之后未返回不能再提交
      startTime: '', // 打开该页面记录时间
      contentReadOnly: true
    }
  },
  beforeMount () {
    this.startTime = new Date().getTime()
    const relMatterId = this.$route.params.id
    const certCode = this.$route.params.certCode
    const cusName = this.$route.params.cusName
    if (relMatterId && certCode && cusName) {
      this.relMatterId = relMatterId
      this.certCode = certCode
      this.cusName = cusName
    }
    if (this.$route.params.item || localStorage.getItem('FRpostData')) {
      const paramsData = this.$route.params.item ? this.$route.params.item : JSON.parse(localStorage.getItem('FRpostData'))
      this.handleToModifyFollowRecordData(paramsData)
    } else {
      // 添加登陆人到项目成员
      this.handleToItemPerson()
    }
  },
  destroyed () {
    this.$store.commit('delLocationInfo', '')
  },
  methods: {
    // 显示日历文本
    textRender () {
      const args = Array.prototype.slice.call(arguments)
      const typeFormat = args[0] // 类型
      const column2Value = args[3] // 第3列选中值
      if (typeFormat === 'dd') {
        return `${column2Value}日`
      }
    },
    // 选择日期
    onDatePickerConfirm (columnsValue) {
      this.visitDate = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
    },
    // 读取压缩照片内容
    // async afterAddFollowupRead (file) {
    //   const imgData = await compressImage(file.content)
    //   const beforeSize = (file.file.size / 1024 / 1024).toFixed(2)
    //   const afterSize = (imgData.size / 1024 / 1024).toFixed(2)
    //   const uploadData = (beforeSize < 1 || afterSize > beforeSize) ? file.file : imgData
    //   const formdata = new FormData()
    //   formdata.append('file', uploadData, file.file.name)
    //   const result = await postfile('/api/CBMS-APP/docEReceive/upload', formdata)
    //   if (result.success) {
    //     this.docEReceiveList.push({
    //       downloadUrl: result.data.downloadUrl,
    //       pk: result.data.pk
    //     })
    //     this.followupimgs.push(result.data.downloadUrl)
    //   } else {
    //     this.$toast.success('上传图片出错')
    //   }
    // },

    // 读取压缩照片内容
    async afterAddFollowupRead (fileList) {
      if (Array.isArray(fileList)) {
        for (let i = 0; i < fileList.length; i++) {
          await this.handleToSendPic(fileList[i])
        }
      } else {
        await this.handleToSendPic(fileList)
      }
    },
    // 上传图片
    async handleToSendPic (file) {
      const imgData = await compressImage(file.content)
      const beforeSize = (file.file.size / 1024 / 1024).toFixed(2)
      const afterSize = (imgData.size / 1024 / 1024).toFixed(2)
      const uploadData = (beforeSize < 1 || afterSize > beforeSize) ? file.file : imgData
      const formdata = new FormData()
      formdata.append('file', uploadData, file.file.name)
      const result = await postfile('/api/CBMS-APP/docEReceive/upload', formdata)
      if (result.success) {
        this.docEReceiveList.push({
          downloadUrl: result.data.downloadUrl,
          pk: result.data.pk
        })
        this.followupimgs.push(result.data.downloadUrl)
      } else {
        this.$toast.success('上传图片出错')
        return false
      }
    },
    // 显示图片
    showViewer (index) {
      this.followupviewerIndex = index
      this.followupisViewerShow = true
    },
    // 删除照片
    handleToDeleteImage (index) {
      const imgUrl = this.followupimgs[index]
      this.$dialog.confirm({
        title: '',
        message: '确认删除该照片'
      })
        .then(async () => {
          this.docEReceiveList = this.docEReceiveList.filter(item => item.downloadUrl !== imgUrl)
          this.followupimgs.splice(index, 1)
        })
        .catch(() => {
          this.$toast.success('已取消')
        })
    },
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.mmRecordStaffList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.mmRecordStaffTag.push(this.$cookies.get('actorno'))
    },
    // 获取拜访客户
    async handleToRecordGetVisitCustom () {
      this.status = '2'
      const result = await get('/api/CBMS-APP/mmMarketMatter/popList', {})
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.visitModeFlag = true
        this.visitCustomList = result.data
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 选择拜访客户
    handleToSelectVisitCustom (item) {
      this.status = ''
      document.body.style.overflow = 'auto'
      this.visitModeFlag = false
      this.certCode = item.certCode
      this.cusName = item.cusName
      this.relMatterId = item.id
    },
    // 获取跟进方式
    async handleToRecordGetVisitMode () {
      this.FollowTypeTextList = []
      const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
        opttype: 'STD_MM_FOLLOW_TYPE'
      })
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.followTypeFlag = true
        this.followTypeList = result.data
        result.data.forEach(item => {
          this.FollowTypeTextList.push(item.cnname)
        })
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 选择跟进方式
    handleToSelectVisitMode (val) {
      document.body.style.overflow = 'auto'
      this.followTypeFlag = false
      const Objdata = this.followTypeList.filter(item => item.cnname === val)[0]
      this.followType = Objdata.enname
      this.followType_text = Objdata.cnname
    },
    // 关闭跟进方式选择页面
    handleToFollowCancleFloat () {
      document.body.style.overflow = 'auto'
      this.followTypeFlag = false
    },
    // 获取跟进人
    async handleToRecordGetFollowPerson () {
      const result = await get('/api/CBMS-APP/sUser/listByComBrId', {})
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.followRecordFlag = true
        this.followRecordPersonList = result.data.records
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 添加跟进人
    handleToAddRecordFollowPerson (itemObj) {
      if (this.mmRecordStaffTag.includes(itemObj.actorno)) {
        this.mmRecordStaffTag.splice(this.mmRecordStaffTag.indexOf(itemObj.actorno), 1)
        this.mmRecordStaffList = this.mmRecordStaffList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.mmRecordStaffList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.mmRecordStaffTag.push(itemObj.actorno)
      }
    },
    // 完成添加跟进人
    handleToAddRecordPersonComplete () {
      document.body.style.overflow = 'auto'
      this.followRecordFlag = false
    },
    // 删除已有跟进记录
    handleToDelFollowRecord (routerName, id) {
      const _this = this
      if (this.id) {
        this.$dialog.confirm({
          title: _this.cusName,
          message: '确认删除营销日志'
        })
          .then(async () => {
            const result = await post('/api/CBMS-APP/mmFollowRecord/remove', { id: this.id })
            if (result.success) {
              this.$toast.success({
                message: '已删除',
                onClose: () => {
                  if (routerName) {
                    this.$router.push({ name: routerName, params: { id } })
                  } else {
                    this.$router.push('/')
                    // this.$router.push('/followup')
                  }
                }
              })
            }
          })
          .catch(() => {
            this.$toast.success('已取消')
          })
      } else {
        this.$toast.success({
          message: '新建营销日志无法删除',
          duration: 4000
        })
      }
    },
    // 保存跟进记录
    async handleToSaveFollowRecord (routerName, id) {
      const FRSavepostData = {
        id: this.id,
        certCode: this.certCode,
        cusName: this.cusName,
        address: this.$store.state.locationData.address,
        lng: this.$store.state.locationData.lng,
        lat: this.$store.state.locationData.lat,
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        relMatterId: this.relMatterId,
        visitDate: this.visitDate,
        followType: this.followType,
        isContinue: this.isContinue,
        remark: this.remark,
        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.mmRecordStaffList
      }
      this.checkFieldList = getFormEmptyField({ cusName: this.cusName })
      if (this.checkFieldList.length === 0 && this.postFlag) {
        this.postFlag = false
        const result = await postjson('/api/CBMS-APP/mmFollowRecord/saveDraft', FRSavepostData)
        if (result.success) {
          this.$toast.success({
            message: '营销日志保存草稿成功',
            onClose: () => {
              this.postFlag = true
              if (routerName) {
                this.$router.push({ name: routerName, params: { id } })
              } else {
                this.$router.push('/')
              }
            }
          })
        } else {
          this.postFlag = true
          this.$toast.success('营销日志保存草稿失败')
        }
      } else {
        this.checkFieldList.forEach(item => {
          if (item === 'docEReceiveList') {
            this.$toast.success('未上传图片')
            return false
          } else if (item === 'mmRecordStaffList') {
            this.$toast.success('跟进人未添加')
            return false
          } else {
            this.$toast.success('有内容未填写')
            return false
          }
        })
      }
    },
    // 添加跟进记录
    async handleToSubmitFollowRecord (routerName, id) {
      console.log('mmRecordStaffList', this.mmRecordStaffList.slice(0, 3))
      const FRSubmitpostData = {
        id: this.id,
        certCode: this.certCode,
        cusName: this.cusName,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        relMatterId: this.relMatterId,
        visitDate: this.visitDate,
        followType: this.followType,
        isContinue: this.isContinue,
        remark: this.remark,
        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.mmRecordStaffList
      }
      this.checkFieldList = getFormEmptyField(FRSubmitpostData)
      if (this.checkFieldList.length === 0 && this.postFlag) {
        this.postFlag = false
        const result = await postjson('/api/CBMS-APP/mmFollowRecord/submitSave', FRSubmitpostData)
        if (result.success) {
          this.$toast.success({
            message: '营销日志添加成功',
            onClose: () => {
              this.postFlag = true
              if (routerName) {
                this.$router.push({ name: routerName, params: { id } })
              } else {
                this.$router.push('/')
              }
            }
          })
        } else {
          this.postFlag = true
          this.$toast.success('营销日志添加失败')
        }
      } else {
        this.checkFieldList.forEach(item => {
          if (item === 'docEReceiveList') {
            this.$toast.success('未上传图片')
            return false
          } else if (item === 'mmRecordStaffList') {
            this.$toast.success('跟进人未添加')
            return false
          } else {
            this.$toast.success('有内容未填写')
            return false
          }
        })
      }
    },
    // 修改跟进记录
    async handleToModifyFollowRecordData (item) {
      this.FollowTypeText = await getFollowupType()
      for (const key in item) {
        if (key === 'docEReceiveList' && item.docEReceiveList.length > 0) {
          item.docEReceiveList.forEach(item => {
            this.followupimgs.push(item.downloadUrl)
            this.docEReceiveList.push({
              pk: item.pk,
              downloadUrl: item.downloadUrl
            })
          })
        } else if (key === 'followType') {
          this.FollowTypeText.forEach(type => {
            if (type.enname === item.followType) {
              this.followType_text = type.cnname
              this.followType = item.followType
            }
          })
        } else if ((key === 'address' || key === 'lng' || key === 'lat' || key === 'locationDate')) {
          const payLoad = { ...this.$store.state.locationData, [key]: item[key] }
          this.$store.commit('setLocationFunc', payLoad)
        } else if (key === 'remark') {
          this[key] = item[key] ? item[key] : ''
        } else if (key === 'couldEdit') {
          this.contentReadOnly = item[key] && !(this.$route.params.routeTag === 'public' || this.$route.params.routeTag === 'hismarket')
        } else if (key === 'actornos') {
          this.mmRecordStaffTag = Array.from(new Set(item[key].split(','))).filter(s => s && s.trim())
        } else {
          this[key] = item[key]
        }
      }
      if (item.id) {
        const hisRecordResult = await get('/api/CBMS-APP/mmFollowRecord/info', { id: item.id })
        this.mmFollowRecordHisList = hisRecordResult.data.mmFollowRecordHisList
      }
    },
    // 选择历史版本
    handleToHisRecord (hisitem) {
      this.remark = hisitem.remark
      this.hisId = hisitem.id
      this.$toast.success(`当前营销日志版本：${hisitem.updateDate.split(' ')[0]}`)
    },
    // 取消按钮触发的事件
    handleToCanCelAddRecordBtn (routerName, routeTag) {
      if (routerName) {
        this.$router.push({ name: routerName, params: { id: this.$route.params.id, routeTag } })
      } else {
        // this.$router.push('/followup')
        this.$router.push('/')
      }
    },
    // 跳转到地图页面
    handleToRecordToMap () {
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({ name: 'marketmap', params: { localName: 'addfollowup', modifyTag, routerName, id } })
    },
    // 添加客户渠道
    handleToForwardAddSelectMM () {
      this.status = ''
      document.body.style.overflow = 'auto'
      this.visitModeFlag = false
      this.$router.push({ name: 'selectmm', params: { routerName: 'addfollowup' } })
    },
    // 取消客户渠道
    handleToCancleSelectCustom () {
      this.status = ''
      document.body.style.overflow = 'auto'
      this.visitModeFlag = false
    },
    // 选择不继续跟进弹出提示
    handleToChangeIsContinue () {
      this.$toast.success({
        message: '提交后系统将自动终结营销事项！',
        duration: 4000
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    const FRpostData = {
      id: this.id,
      certCode: this.certCode,
      cusName: this.cusName,
      relMatterId: this.relMatterId,
      visitDate: this.visitDate,
      followType: this.followType,
      isContinue: this.isContinue,
      remark: this.remark,
      docEReceiveList: this.docEReceiveList,
      mmRecordStaffList: this.mmRecordStaffList,
      mmRecordStaffTag: this.mmRecordStaffTag
    }
    const tourl = to.path
    const fromurl = from.path
    const endTime = new Date().getTime()
    const time = endTime - this.startTime
    post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl, time })
    if (to.name === 'marketmap' && from.name === 'addfollowup') {
      localStorage.setItem('FRpostData', JSON.stringify(FRpostData))
      next()
    } else {
      localStorage.removeItem('FRpostData')
      next()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addfollowup
  position : relative
  width : 100vw
  min-height : 100vh
  background-color : #f7f7f7
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 96px
  .addfollowup--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addfollowup--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
  .addfollowup--line
    height : 85px
    width : 100vw
  .addfollowup--info
    .addfollowup--info--noinput
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
    .addfollowup--info--item
      display : flex
      justify-content : center
      align-items : center
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &:nth-child(1)
        margin-top : 0
      .item--text
        width : 200px
      .item--desc
        flex : 1
        text-align : left
        text-indent : 32px
      .item--report
        flex : 1
        text-align : right
        color : #007aff
        text-decoration: underline
      .item--radio
        flex : 1
        &>>>.van-radio-group
          padding-left : 16px
      .item--icon
        width : 100px
        text-align : right
        font-size: 34px
        color : #4282e1
      &>>>.md-field-item
        width : 100vw
      &>>>.md-field-item-content:before
        border-bottom : none
    .addfollowup--info--camera
      display : flex
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--img--icon
        text-align : center
        line-height : 47px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 64px
    .addfollowup--info--img
      margin : 0 8px
      .md-example-child-reader
        .image-reader-list
          background-color : #ffffff
          float : left
          width : 100%
          .image-reader-item
            position : relative
            float : left
            width : 23.5%
            padding-bottom : 23.5%
            margin-bottom : 2%
            margin-right : 2%
            background : #FFF
            box-shadow : 0 5px 20px rgba(197, 202, 213, .25)
            box-sizing : border-box
            list-style : none
            border-radius : 4px
            background-size : cover
            overflow : hidden
            &:nth-of-type(4n)
              margin-right : 0
            &.add
              .md-icon
                position : absolute
                top : 40%
                left : 50%
                transform : translate(-50%, -50%)
                opacity : .5
              p
                position : absolute
                top : 50%
                left : 0
                width : 100%
                margin-top : 15px
                font-size : 22px
                color : #CCC
                text-align : center
            .image-reader-item-del
              position : absolute
              top : 0
              right : 0
              z-index : 3
              opacity : .8
              .md-icon-close
                font-size : 24px
    .addfollowup--info--person
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--persons--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .item--persons--desc
        display : flex
        align-items : center
        padding : 16px 0
        border-bottom : 1px solid #8b8787
        .desc--person
          background-color : #4282e1
          margin-right : 32px
          width : 100px
          height : 100px
          line-height : 100px
          text-align : center
          border-radius : 50%
          color : #ffffff
          font-family: MyriadPro-Regular
          font-size: 28px
          font-weight: normal
          font-stretch: normal
        .desc--person--plus
          font-size : 32px
    .addfollowup--info--version
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .version--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .version--item
        display : flex
        align-items : center
        padding : 16px 0
        line-height : 1.5
        background-color : #ffffff
        border-bottom : 1px solid #8b8787
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .version--item--text
          width : 250px
        .version--item--desc
          flex : 1
        .version--item--icon
          width : 100px
          text-align : right
          font-size: 34px
        &.active
          background-color : #007aff
          .version--item--text,.version--item--icon
            color : #ffffff
  .addfollowup--footer
    position : fixed
    left : 0
    bottom :0
    width : 100vw
    display : flex
    z-index : 100
    .addfollowup--footer--save,.addfollowup--footer--del
      flex : 1
      text-align : center
      padding : 32px 0
      background-color : #eabf62
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
    .addfollowup--footer--save
      border-right : 1px solid #ffffff
    .addfollowup--footer--del
      border-left : 1px solid #ffffff
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .visit--title
      position : fixed
      top: 0
      left: 0
      width : 100vw
      z-index : 12
      display : flex
      background-color : #687591
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
        color : #ffffff
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
        color : #ffffff
    .visit--line
      height : 80px
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : left
        .text-title
          padding-bottom : 8px
          font-size: 32px
          font-weight: normal
          font-stretch: normal
        .text-desc
          padding-top : 8px
          color : #007aff
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
  &>>>.md-popup-cancel
    font-size : 38px
    padding-left : 28px
  &>>>.md-popup-confirm
    font-size : 38px
    padding-right : 28px
</style>
